import React from "react";
import { BrowserRouter } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";
import AuthContextProvider from "./components/contexts/AuthContext";
import StoreContextProvider from "./components/contexts/StoreContext";
import SuperAdminRoute from "./components/routes/SuperAdminRoute";
import theme from "./theme";

const App: React.FC = () => {
  return (
    <ChakraProvider theme={theme}>
      <BrowserRouter>
        <AuthContextProvider>
          <StoreContextProvider>
            <SuperAdminRoute />
          </StoreContextProvider>
        </AuthContextProvider>
      </BrowserRouter>
    </ChakraProvider>
  );
};

export default App;

